"use client";
import Image from "next/image";
import { Link } from "@/i18n/routing";
import HeaderItemList from "./headerItemList";
import { FaPhone, FaWhatsapp } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import HeaderLink from "./headerLink";
import Navbar from "../navbar/navbar";
import useLocalizer from "@/hooks/useLocalizer";
import Flex from "@/components/core/flex";
import BalanceColor from "@/components/core/balanceColor";
import { formatPhoneNumber, getFilePath } from "@/lib/utils/utils";
import Text from "@/components/shared/text";
import { InfoResponse } from "@/types/info";
import DynamicIcon from "@/components/shared/dynamicIcon";
interface HeaderProps {
  data?: InfoResponse | null;
}
export default function Header({ data }: HeaderProps) {
  const { t, isRtl } = useLocalizer();
  return (
    <header className="relative">
      <BalanceColor leftColor="primary" rightColor="secondary" />
      <Flex
        className="md:justify-between h-32"
        justify="center"
        fullWidth
        items="center"
        direction="row"
        spacing={{ all: 4 }}
        asContainer
      >
        <Link href="/">
          {data?.info?.lightLogo && (
            <Image
              src={getFilePath(data?.info?.lightLogo?.key) ?? ""}
              alt={
                (isRtl ? data?.info?.arBrandName : data?.info?.enBrandName) ??
                "logo"
              }
              height={52}
              width={80}
              priority
              placeholder="empty"
            />
          )}
        </Link>
        <Flex spacing={{ all: 4 }} items="baseline">
          <HeaderItemList
            className="hidden lg:flex"
            items={[
              {
                icon: FaPhone,
                title: t("titles.phone"),
                item: (
                  <Link
                    aria-label={t("titles.phone")}
                    href={`tel:${data?.info?.mobileNumber}`}
                    className="hover:text-primary"
                  >
                    <Text as="span">
                      {formatPhoneNumber(
                        data?.info?.mobileNumber ?? "",
                        "+(XXX)-XXXXXXXXX",
                      )}
                    </Text>
                  </Link>
                ),
              },
              {
                icon: IoMdMail,
                title: t("titles.email"),
                item: (
                  <Link
                    aria-label={t("titles.email")}
                    href={`mailto:${data?.info?.email}`}
                    className="hover:text-primary"
                  >
                    <Text as="span">{data?.info?.email}</Text>
                  </Link>
                ),
              },

              {
                icon: FaWhatsapp,
                title: t("titles.whatsapp"),
                item: (
                  <Link
                    href={`https://wa.me/${data?.info?.whatsAppMobileNumber}`}
                    className="hover:text-primary"
                  >
                    <Text as="span">
                      {formatPhoneNumber(
                        data?.info?.whatsAppMobileNumber ?? "",
                        "+(XXX)-XXXXXXXXX",
                      )}
                    </Text>
                  </Link>
                ),
              },
            ]}
          />
          <Flex
            className="md:flex hidden"
            direction="row"
            spacing={{ all: 3 }}
            items="center"
          >
            {data?.socialMedia?.map((social, index) => (
              <HeaderLink
                key={index}
                href={social.linkHref ?? "#"}
                icon={<DynamicIcon name={social?.icon?.code ?? ""} />}
              />
            ))}
          </Flex>
        </Flex>
      </Flex>
      <Navbar data={data} />
    </header>
  );
}
